import { render, staticRenderFns } from "./ChargeCode.vue?vue&type=template&id=20d08e27&scoped=true&"
import script from "./ChargeCode.vue?vue&type=script&lang=js&"
export * from "./ChargeCode.vue?vue&type=script&lang=js&"
import style0 from "./ChargeCode.vue?vue&type=style&index=0&id=20d08e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d08e27",
  null
  
)

export default component.exports